import type { ReactNode } from 'react';
import { Construction } from 'lucide-react';

import { Tooltip } from '@/components/ui/tooltip';
import type { CustomerConfig } from '@/entities/customer-config';
import { useMe } from '@/hooks/use-me';
import { FeatureFlag } from '@/types/feature-flag';

export type AppSidebarInternalIconProps = {
  featureFlag: keyof CustomerConfig['featureFlags'];
  /** Custom tooltip content to override default message */
  tooltip?: ReactNode;
};

export function AppSidebarInternalIcon({
  featureFlag,
  tooltip,
}: AppSidebarInternalIconProps) {
  const me = useMe();

  // Show this icon only to internal users
  if (!me.isInternal) {
    return null;
  }

  // Hide this icon for demo_bess (as we use internal feature to demo)
  if (me.config.id === '49') {
    return null;
  }

  const isInternal =
    me.config.featureFlags[featureFlag] === FeatureFlag.INTERNAL;

  // Show this icon only if the feature is internal
  if (!isInternal) {
    return null;
  }

  const defaultTooltip = <p>INTERNAL - not yet available for {me.tenant}</p>;

  return (
    <div className="absolute right-2 top-1/2 -mt-px size-4 -translate-y-1/2">
      <Tooltip delay position="right" content={tooltip ?? defaultTooltip}>
        <Construction className="size-full text-yellow-600" />
      </Tooltip>
    </div>
  );
}
